/**
 * Push Notification Service — Web stub
 *
 * Web platform doesn't support expo-notifications (no native push token,
 * no foreground handler, no user-facing permissions UI from the SDK).
 * Importing `expo-notifications` at module level on web triggers the
 * library's PushTokenManager to log:
 *
 *   [expo-notifications] Listening to push token changes is not yet
 *   fully supported on web. Adding a listener will have no effect.
 *
 * This stub mirrors the public API of `lib/notifications.ts` (the native
 * implementation) with no-op behavior, so importers don't need Platform
 * checks. Metro auto-resolves to this file on web builds.
 *
 * NocoDB DD-CLEANUP-NOTIFY-001
 */

// Minimal subscription shape compatible with the native EventSubscription
type EventSubscription = { remove: () => void };

const NOOP_SUBSCRIPTION: EventSubscription = { remove: () => undefined };

export async function requestNotificationPermission(): Promise<boolean> {
  return false;
}

export async function registerForPushNotifications(): Promise<{
  token: string | null;
  status: 'granted' | 'denied' | 'undetermined';
}> {
  return { token: null, status: 'undetermined' };
}

export function addNotificationResponseListener(
  _handler: (response: unknown) => void
): EventSubscription {
  return NOOP_SUBSCRIPTION;
}

export function addNotificationReceivedListener(
  _handler: (notification: unknown) => void
): EventSubscription {
  return NOOP_SUBSCRIPTION;
}
